import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import "../style/TripClosure.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faBus } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import { Rating } from "react-simple-star-rating";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation } from "react-router-dom";
import StatusTypeModel from "./Components/StatusSubModal";

function formatDateTime(dateString) {
  const date = new Date(dateString);

  // Format the day, month (3-char), and year
  const day = date.getDate().toString().padStart(2, "0"); // Ensure 2 digits for day
  const month = date.toLocaleString("en-US", { month: "short" }); // 'Sep' for September
  const year = date.getFullYear(); // Get the year

  // Format the time as 'h:mm AM/PM'
  const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure 2 digits for minutes
  const ampm = date.getHours() >= 12 ? "PM" : "AM"; // Determine AM or PM

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

const DateTimeConvert = (str) => {
  const date = new Date(str);

  const istOffset = 5.5 * 60;
  const localDate = new Date(date.getTime() + istOffset * 60 * 1000);

  const day = localDate.getUTCDate();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[localDate.getUTCMonth()];
  const year = localDate.getUTCFullYear();

  let hours = localDate.getUTCHours();
  const minutes = localDate.getUTCMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  return formattedDate;
};

const DateTimeDisplay = (str) => {
  //console.log("Time",str)
  const date = new Date(str);
  const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);
  const formattedDate = istDate.toISOString().slice(0, 16);
  return formattedDate;
};

const convert = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

export default function TripClosure(prop) {
  const location = useLocation();
  const passedState = location.state;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [Input, setInputs] = useState({});
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  const [ClosureList, SetClosureList] = useState([]);
  const [BookingList, SetBookingList] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [PaymentMode, SetPaymentMode] = useState([]);
  const [PaymentStatus, SetPaymentStatus] = useState([]);
  const [Distance, SetDistance] = useState(0);
  const [Fuel, SetFuel] = useState(0);

  const [searchQuery, setSearchQuery] = useState("");

  const [isDateTime1, setIsDateTime1] = useState(false);
  const [isDateTime2, setIsDateTime2] = useState(false);

  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const [subModalIsOpen, setSubModalIsOpen] = useState(false);
  const [statusType, setStatusType] = useState(null);
  const [statusTypeSub, setStatusTypeSub] = useState({
    Status: null,
    Status_Ref: null,
  });

  const handleSubModalOpen = () => setSubModalIsOpen(true);
  const handleSubModalClose = () => setSubModalIsOpen(false);

  const handleStatusOnChange = async (e) => {
    let { name, value } = e.target;
    setStatusTypeSub({ ...statusTypeSub, [name]: value.toUpperCase() });
  };

  function selectStatusType(statusType) {
    switch (statusType) {
      case "Mode of Payment":
        return "Mode_of_Payment";
        break;
      case "Payment Status":
        return "Payment_Status";
        break;

      default:
        break;
    }
  }

  const handleStatusTypeSubjectSubmit = async (event) => {
    event.preventDefault();
    const status = statusType ? selectStatusType(statusType) : "";
    console.log(status, statusType);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/AddStatusTypeSub/${status}`,
          statusTypeSub,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            setStatusTypeSub({ Status: null, Status_Ref: null });
            fetchModeOfPayment();
            setStatusType(null);
            handleSubModalClose();
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const filteredBooking = searchQuery
    ? BookingList.filter((item) =>
        item.Customer_Name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : BookingList;

  const CustomerRattingF = (rate) => {
    setSelectedBooking({
      ...selectedBooking,
      customerRating: rate,
    });
  };
  const DriverRattingF = (rate) => {
    setSelectedBooking({
      ...selectedBooking,
      driverRating: rate,
    });
  };
  const ComfortRattingF = (rate) => {
    setSelectedBooking({
      ...selectedBooking,
      comfortRating: rate,
    });
  };

  console.log("tripclosure:", selectedBooking);

  const fetchDistance = async () => {
    try {
      const response = await axios.get(
        "https://app.fleettrack.co.in/api/get_vehicles?token=fleettrackapi_c9nZIjOPEXNPvO6RUU4FJTygEAbXBiWY&email=fleettrackapi@gmail.com"
      );
      //console.log("API",response.data);
      SetDistance(Math.round(response.data[0].odoDistance));
      SetFuel(response.data[1].fuelLitre);
    } catch (e) {
      //  FailedMSG("API Fetch Failed")
      console.error(e);
    }
  };
  const fetchBookingList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tripbooking/FetchTripBookingList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      console.log("Fetched data:", response.data); // Log the fetched data
      SetBookingList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const fetchClosureList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tripclosure/FetchTripClosureList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      SetClosureList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const fetchModeOfPayment = async () => {
    try {
      const response1 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Mode_Of_Payment`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      const response2 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Payment_Status`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      SetPaymentStatus(response2.data);
      SetPaymentMode(response1.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchClosureList();
    fetchBookingList();
    fetchModeOfPayment();
    fetchDistance();
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, []);

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const handleEdit = (Booking) => {
    const selectedId = ClosureList.find(
      (p) => p.Booking_Id === Booking.Booking_Id
    );

    const InitStateEdit = {
      advancefare: Booking.Fare,
      adavancepaid: Booking.Paid,
      advancebalance: Booking.Balance,
      BookingId: Booking.Booking_Id,
      customerName: Booking.Customer_Name,
      regNo: Booking.Register_Number,
      pickupLocation: Booking.Pickup_Location,
      dropLocation: Booking.Drop_Location,
      totalFare: selectedId ? selectedId.Fare : Booking.Fare,
      paid: selectedId ? selectedId.Paid : Booking.Paid,
      balance: selectedId ? selectedId.Balance : Booking.Balance,
      passengerCount: selectedId ? selectedId.Passenger_Count : null,
      tripdistanceTravelled: Distance ? Distance : null,
      distanceTravelled: Distance ? Distance : null,
      fuelConsumption: Fuel ? Fuel : null,
      acUnits: selectedId ? selectedId.AcUnits : null,
      araivalDateTime: selectedId
        ? selectedId.Araival_Datetime == null
          ? null
          : selectedId.Araival_Datetime
        : Booking.Araival_Datetime,
      departureDateTime: selectedId
        ? selectedId.Departure_Datetime == null
          ? null
          : selectedId.Departure_Datetime
        : Booking.Departure_Datetime,
      tripType: selectedId ? selectedId.Trip_Type : Booking.Trip_Type,
      delayIssue: selectedId ? selectedId.Any_Delay_Issue : null,
      discount: selectedId ? selectedId.Discount : null,
      modeOfPayment: selectedId ? selectedId.Mode_of_Payment : null,
      paymentStatus: selectedId ? selectedId.Payment_Status : null,
      driverSalary: selectedId ? selectedId.Driver_Salary : null,
      fuelCharges: selectedId ? selectedId.Fuel_Charges : null,
      tollCharges: selectedId ? selectedId.Toll_Charges : null,
      repairCost: selectedId ? selectedId.Repair_Cost : null,
      additionalCharges: selectedId ? selectedId.Additional_Charges : null,
      additionalNotes: selectedId ? selectedId.Additional_Notes : null,
      repairNotes: selectedId ? selectedId.Repair_Notes : null,
      customerFeedback: selectedId ? selectedId.Customer_Feedback : null,
      driverFeedback: selectedId ? selectedId.Driver_Feedback : null,
      customerRating: selectedId ? selectedId.Customer_Rating : null,
      driverRating: selectedId ? selectedId.Driver_Rating : null,
      comfortRating: selectedId ? selectedId.Bus_Comfort_Rating : null,
      comments: selectedId ? selectedId.Comments_on_Comfort : null,
      user: passedState.username,
    };
    setSelectedBooking(InitStateEdit);
    //console.log(InitStateEdit)
    setModalIsOpen(true);
  };

  const handleModalClose = () => {
    const confirmClose = window.confirm("Are you sure you want to close?");
    if (confirmClose) {
      setModalIsOpen(false);
      setSelectedBooking(null);
    }
  };

  /*

  const InitState = {
    customerName: null,
    regNo:null,
    distanceTravelled:null,
    pickupLocation:null,
    dropLocation:null,
    araivalDateTime:null,
    delayIssue:null,
    totalFare:null,
    paid:null,
    balance:null,
    discount:null,
    modeOfPayment:null,  
    paymentStatus:null,
    driverSalary:null,
    fuelCharges:null,
    tollCharges:null,
    reportCost:null,
    additionalCharges:null,
    reportNotes:null,
    customerFeedback:null,
    driverFeedback:null,
    comments:null,
    user:passedState.username
}
const [formData, setFormData] = useState(InitState);


const handleTripSelectChange = (e) => {
  console.error(e);
  const selectedIndex = BusList.findIndex(item => item.Bus_Name === e);
  const BusName= BusList[selectedIndex].Bus_Name;
  const BusModelName= BusList[selectedIndex].Model_Name;
  const BusStatus= BusList[selectedIndex].Bus_Status;
  const Wifi = BusList[selectedIndex].Wifi;
  const LastService= BusList[selectedIndex].Last_Service_Date;
  const BusRegNo= BusList[selectedIndex].Register_Number;
  setFormData({
    ...formData,
    busName : BusName,
    busRegNo: BusRegNo,
    busModelName : BusModelName,
    busStatus: BusStatus,
    wifi : Wifi,
    lastServiceDate : LastService == null ? null : convert(LastService.toString())
  });
};
*/

  const handleClick = () => {
    setIsDateTime1(!isDateTime1);
  };
  const handleClick1 = () => {
    setIsDateTime1(!isDateTime1);
  };
  const handleClick01 = () => {
    setIsDateTime2(!isDateTime2);
  };
  const handleClick02 = () => {
    setIsDateTime2(!isDateTime2);
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    if (
      name === "repairNotes" ||
      name === "customerFeedback" ||
      name === "driverFeedback" ||
      name === "comments" ||
      name === "additionalNotes" ||
      name === "delayIssue"
    ) {
      let result = pattern.test(value);
      //console.log(selectedBooking)
      if (result) {
        setSelectedBooking({
          ...selectedBooking,
          [name]: value.replace(pattern, ""),
        });
      } else {
        setSelectedBooking({
          ...selectedBooking,
          [name]: value,
        });
      }
    } else if (
      name === "acUnits" ||
      "fuelCharges" ||
      "tollCharges" ||
      "reportCost" ||
      "additionalCharges" ||
      "totalFare" ||
      "paid" ||
      "discount"
    ) {
      if (value > 9999999) {
        setSelectedBooking({
          ...selectedBooking,
          [name]: value.replace(/[^0-9]/g, "").slice(0, 7),
        });
      } else {
        setSelectedBooking({
          ...selectedBooking,
          [name]: value.replace(/[^0-9]/g, ""),
        });
      }
    } else {
      setSelectedBooking({
        ...selectedBooking,
        [name]: value,
      });
    }
  };
  const handleUpdate0 = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    let result = pattern.test(value);

    if (result) {
      setSelectedBooking({
        ...selectedBooking,
        [name]: value.replace(pattern, ""),
      });
    } else {
      setSelectedBooking({
        ...selectedBooking,
        [name]: value,
      });
    }
  };
  const handleUpdateDate = (e) => {
    const { name, value } = e.target;
    //console.log("brvvuhfv",value)
    setSelectedBooking({
      ...selectedBooking,
      [name]: value.slice(0, 16),
    });
  };

  const handleUpdateStatus = (e) => {
    setSelectedBooking({
      ...selectedBooking,
      [e.target.name]: e.target.value,
    });
  };

  const UpdateForm = async (e) => {
    e.preventDefault();
    //console.log(selectedBooking)
    try {
      await axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/tripclosure/UpdateTripClosure/${selectedBooking.BookingId}`,
          selectedBooking,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          setSelectedBooking([]);
          fetchBookingList();
          fetchClosureList();
          // if(res.data.i === "0"){window.location.href=`/Feedback/${res.data.id}`}
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    closeModal();
  };

  const handleDelete = async (Booking) => {
    try {
      const confirm = window.confirm("Are you sure you want to delete this?");
      if (!confirm) return;
      await axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/tripclosure/DeleteTripClosure/${Booking.Booking_Id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          fetchBookingList();
          fetchClosureList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  return (
    <>
      <ToastContainer />
      <Appbar
        username={passedState.username}
        rights={passedState.rights}
      ></Appbar>
      <div className="TripClosure">
        <Menu
          username={passedState.username}
          rights={passedState.rights}
        ></Menu>
        <div className="TripClosurePage">
          <p className="TripClosureLabel">Trip Closure</p>
          <div className="TripClosureHeader">
            <div className="TripClosureSearch">
              <input
                className="TripClosureInput"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Customer Name"
              ></input>
              <button className="TripClosureSearchBtn">
                <FontAwesomeIcon
                  className="TripClosureSearchIcon"
                  title="Search"
                  icon={faSearch}
                ></FontAwesomeIcon>
              </button>
            </div>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleModalClose}
            contentLabel="Closure Form"
            shouldCloseOnOverlayClick={false}
            center
            style={{
              overlay: {
                background: "rgba(0,0,0,0.6)",
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              },
              content: {
                background: "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
                position: "absolute",
                top: "40px",
                left: "25%",
                right: "25%",
                bottom: "40px",
                height: "auto",
                width: "50%",
                overflow: "scroll",
              },
            }}
          >
            <FontAwesomeIcon
              className="TripClosureFormCloseBtn"
              onClick={handleModalClose}
              title="Close"
              icon={faClose}
            ></FontAwesomeIcon>
            <p className="TripClosureFormHeadLabel"> Trip Closure</p>
            <form className="TripClosureForm" onSubmit={UpdateForm}>
              <div className="TripClosureFormFlex">
                <p className="TripClosureFormGroupLables">Trip Details</p>
                <div className="TripClosureFormGroups">
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Customer Name <span>*</span>
                      </label>
                      <input
                        required
                        placeholder="Customer Name"
                        value={
                          selectedBooking ? selectedBooking.customerName : null
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="customerName"
                      ></input>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Bus Register Number <span>*</span>
                      </label>
                      <input
                        required
                        placeholder="Register Number"
                        value={selectedBooking ? selectedBooking.regNo : null}
                        className="TripClosureFormInputs"
                        type="text"
                        name="regNo"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Trip Distance Travelled (Km){" "}
                      </label>
                      <input
                        placeholder="TripDistance Travelled "
                        onChange={() => {}}
                        value={
                          selectedBooking
                            ? selectedBooking.tripdistanceTravelled
                            : null
                        }
                        className="TripClosureFormInputs"
                        type="number"
                        name="tripdistanceTravelled"
                      ></input>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Overall Distance Travelled (Km){" "}
                      </label>
                      <input
                        placeholder="Overall Distance Travelled "
                        onChange={() => {}}
                        value={
                          selectedBooking
                            ? selectedBooking.distanceTravelled
                            : null
                        }
                        className="TripClosureFormInputs"
                        type="number"
                        name="distanceTravelled"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Actual Pickup Location <span>*</span>
                      </label>
                      <input
                        required
                        placeholder="Location"
                        onChange={handleUpdate0}
                        value={
                          selectedBooking ? selectedBooking.pickupLocation : ""
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="pickupLocation"
                      ></input>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Actual Drop Location <span>*</span>{" "}
                      </label>
                      <input
                        required
                        placeholder="Location"
                        onChange={handleUpdate0}
                        value={
                          selectedBooking ? selectedBooking.dropLocation : ""
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="dropLocation"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Departure Date <span>*</span>
                      </label>
                      <input
                        required
                        type={isDateTime2 ? "datetime-local" : "text"}
                        onFocus={handleClick01}
                        onBlur={handleClick02}
                        readOnly={!isDateTime2}
                        className="TripClosureFormInputs"
                        name="departureDateTime"
                        value={
                          selectedBooking
                            ? selectedBooking.departureDateTime
                              ? formatDateTime(
                                  selectedBooking.departureDateTime.toString()
                                )
                              : selectedBooking.departureDateTime
                            : null
                        }
                        onChange={(e) => handleUpdateDate(e)}
                      ></input>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Arrival Date - Time<span>*</span>
                      </label>
                      <input
                        required
                        type={isDateTime1 ? "datetime-local" : "text"}
                        onFocus={handleClick}
                        onBlur={handleClick1}
                        readOnly={!isDateTime1}
                        className="TripClosureFormInputs"
                        onChange={(e) => handleUpdateDate(e)}
                        value={
                          selectedBooking
                            ? selectedBooking.araivalDateTime
                              ? formatDateTime(
                                  selectedBooking.araivalDateTime.toString()
                                )
                              : selectedBooking.araivalDateTime
                            : null
                        }
                        name="araivalDateTime"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label
                        style={{ marginTop: "10px" }}
                        className="TripClosureFormLabels"
                      >
                        Trip Type <span>* </span>{" "}
                      </label>
                      <select
                        className="TripClosureFormSelects"
                        name="tripType"
                        required
                        value={selectedBooking ? selectedBooking.tripType : ""}
                        onChange={handleUpdateStatus}
                      >
                        <option>Round Trip</option>
                        <option>One-Way Trip</option>
                      </select>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Passengers Count
                      </label>
                      <input
                        placeholder="Count"
                        className="TripClosureFormInputs"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.passengerCount
                            : null
                        }
                        maxLength={2}
                        minLength={1}
                        type="text"
                        name="passengerCount"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        AC Units (BTS / Hr)
                      </label>
                      <input
                        className="TripClosureFormInputs"
                        onChange={handleUpdate}
                        value={selectedBooking ? selectedBooking.acUnits : null}
                        type="number"
                        name="acUnits"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds2">
                      <label className="TripClosureFormLabels">
                        Any Delay Issue
                      </label>
                      <textarea
                        placeholder="Delay Issue"
                        onChange={handleUpdate}
                        value={
                          selectedBooking ? selectedBooking.delayIssue : null
                        }
                        className="TripClosureFormInputs2"
                        type="text"
                        name="delayIssue"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <p className="TripClosureFormGroupLables">Payments</p>
                <div className="TripClosureFormGroups">
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Total Fare (₹)
                      </label>
                      <input
                        placeholder="Total Fare"
                        onChange={handleUpdate}
                        value={
                          selectedBooking ? selectedBooking.totalFare : null
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="totalFare"
                      ></input>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Discount Amount (₹)
                      </label>
                      <input
                        placeholder="₹ Discount Amount"
                        onChange={handleUpdate}
                        value={
                          selectedBooking ? selectedBooking.discount : null
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="discount"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">Paid (₹) </label>
                      <input
                        placeholder="Paid"
                        onChange={handleUpdate}
                        className="TripClosureFormInputs"
                        value={selectedBooking ? selectedBooking.paid : null}
                        type="text"
                        name="paid"
                      ></input>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Balance (₹){" "}
                      </label>
                      <input
                        placeholder="Balance"
                        onChange={handleUpdate}
                        className="TripClosureFormInputs"
                        value={
                          selectedBooking
                            ? (selectedBooking.balance =
                                selectedBooking.totalFare -
                                selectedBooking.paid -
                                selectedBooking.discount)
                            : null
                        }
                        type="number"
                        name="balance"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Mode of Payment{" "}
                        <Link
                          style={{ fontSize: "12px" }}
                          state={{
                            username: passedState.username,
                            rights: passedState.rights,
                          }}
                          to={""}
                          onClick={() => {
                            setStatusType("Mode Of Payment");
                            handleSubModalOpen();
                          }}
                        >
                          {" "}
                          (Add Payment Mode)
                        </Link>{" "}
                      </label>
                      <select
                        onChange={handleUpdateStatus}
                        className=" TripClosureFormSelects"
                        value={
                          selectedBooking ? selectedBooking.modeOfPayment : null
                        }
                        name="modeOfPayment"
                      >
                        <option value={""}>Select</option>
                        {PaymentMode.map((item, index) => (
                          <option key={index} value={item.Status_Ref}>
                            {item.Status_Ref}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Payment Status{" "}
                        <Link
                          style={{ fontSize: "12px" }}
                          state={{
                            username: passedState.username,
                            rights: passedState.rights,
                          }}
                          to={""}
                          onClick={() => {
                            setStatusType("Payment Status");
                            handleSubModalOpen();
                          }}
                        >
                          (Add New Status)
                        </Link>
                      </label>
                      <select
                        onChange={handleUpdateStatus}
                        className="TripClosureFormSelects"
                        value={
                          selectedBooking ? selectedBooking.paymentStatus : null
                        }
                        name="paymentStatus"
                      >
                        <option value={""}>Select</option>
                        {PaymentStatus.map((item, index) => (
                          <option key={index} value={item.Status_Ref}>
                            {item.Status_Ref}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <p className="TripClosureFormGroupLables">Additional Charges</p>
                <div className="TripClosureFormGroups">
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Driver Salary (₹) <span>*</span>
                      </label>
                      <input
                        required
                        placeholder="Driver Salary"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.driverSalary == null
                              ? 0
                              : selectedBooking.driverSalary
                            : null
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="driverSalary"
                      ></input>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Fuel Consumption (L){" "}
                      </label>
                      <input
                        placeholder="Fuel Consumption"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.fuelConsumption == null
                              ? 0
                              : selectedBooking.fuelConsumption
                            : null
                        }
                        className="TripClosureFormInputs"
                        type="number"
                        name="fuelConsumption"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Toll Charges (₹)
                      </label>
                      <input
                        placeholder="Toll Charges"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.tollCharges == null
                              ? 0
                              : selectedBooking.tollCharges
                            : null
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="tollCharges"
                      ></input>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Fuel Charges (₹)
                      </label>
                      <input
                        placeholder="Fuel Charges"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.fuelCharges == null
                              ? 0
                              : selectedBooking.fuelCharges
                            : null
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="fuelCharges"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Repair Cost (₹)
                      </label>
                      <input
                        placeholder="Repair Cost"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.repairCost == null
                              ? 0
                              : selectedBooking.repairCost
                            : null
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="repairCost"
                      ></input>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Additional Charges (₹)
                      </label>
                      <input
                        placeholder="Additional Charges"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.additionalCharges == null
                              ? 0
                              : selectedBooking.additionalCharges
                            : null
                        }
                        className="TripClosureFormInputs"
                        type="text"
                        name="additionalCharges"
                      ></input>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Repair Notes
                      </label>
                      <textarea
                        placeholder="Repair Notes"
                        onChange={handleUpdate}
                        value={
                          selectedBooking ? selectedBooking.repairNotes : null
                        }
                        className="TripClosureFormInputs3"
                        type="text"
                        name="repairNotes"
                      ></textarea>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Additional Notes
                      </label>
                      <textarea
                        placeholder="Additional Notes"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.additionalNotes
                            : null
                        }
                        className="TripClosureFormInputs3"
                        type="text"
                        name="additionalNotes"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <p className="TripClosureFormGroupLables">Feedbacks</p>
                <div className="TripClosureFormGroups">
                  <div className="TripClosureform1">
                    <div className="TripClosureformRatings">
                      <label className="TripClosureFormLabels">
                        Customer Rating{" "}
                      </label>
                      <Rating
                        size={25}
                        initialValue={
                          selectedBooking
                            ? Number(selectedBooking.customerRating)
                            : 0
                        }
                        className="TripClosureStarRatting"
                        emptyColor="white"
                        onClick={CustomerRattingF}
                      ></Rating>
                    </div>
                    <div className="TripClosureformRatings">
                      <label className="TripClosureFormLabels">
                        Driver Rating{" "}
                      </label>
                      <Rating
                        size={25}
                        readonly
                        initialValue={
                          selectedBooking
                            ? Number(selectedBooking.driverRating)
                            : 0
                        }
                        className="TripClosureStarRatting"
                        emptyColor="white"
                        onClick={DriverRattingF}
                      ></Rating>
                    </div>
                    <div className="TripClosureformRatings">
                      <label className="TripClosureFormLabels">
                        Bus Comfort Rating
                      </label>
                      <Rating
                        size={25}
                        readonly
                        initialValue={
                          selectedBooking
                            ? Number(selectedBooking.comfortRating)
                            : 0
                        }
                        className="TripClosureStarRatting"
                        emptyColor="white"
                        onClick={ComfortRattingF}
                      ></Rating>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Customer Feedback{" "}
                      </label>
                      <textarea
                        placeholder="Feedback"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.customerFeedback
                            : null
                        }
                        className="TripClosureFormInputs3"
                        type="text"
                        name="customerFeedback"
                      ></textarea>
                    </div>
                    <div className="TripClosureformFeilds1">
                      <label className="TripClosureFormLabels">
                        Driver Feedback{" "}
                      </label>
                      <textarea
                        placeholder="Feedback"
                        onChange={handleUpdate}
                        value={
                          selectedBooking
                            ? selectedBooking.driverFeedback
                            : null
                        }
                        className="TripClosureFormInputs3"
                        type="text"
                        name="driverFeedback"
                      ></textarea>
                    </div>
                  </div>
                  <div className="TripClosureform1">
                    <div className="TripClosureformFeilds2">
                      <label className="TripClosureFormLabels">Comments</label>
                      <textarea
                        placeholder="Comments"
                        onChange={handleUpdate}
                        value={
                          selectedBooking ? selectedBooking.comments : null
                        }
                        className="TripClosureFormInputs2"
                        type="text"
                        name="comments"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="TripClosureFormFooter">
                <div className="TripClosureFormFooterBtns">
                  <button
                    className="TripClosureFormSubmitBtn"
                    title="Submit"
                    type="submit"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </form>
          </Modal>
          <StatusTypeModel
            isOpen={subModalIsOpen}
            onClose={handleSubModalClose}
            statusTypeSub={statusTypeSub}
            handleChange={handleStatusOnChange}
            handleSubmit={handleStatusTypeSubjectSubmit}
            statusType={statusType}
          />

          <div className="TripClosureList">
            {filteredBooking.length < 1 ? (
              <p
                className="mx-auto"
                style={{ textAlign: "center", width: "100%" }}
              >
                There is No Booking Found
              </p>
            ) : (
              filteredBooking.map((items, index) => {
                //  let selectedId = ClosureList.find(p => p.Booking_Id === BookingList.Booking_Id);
                //  //console.log(ClosureList[index])
                return (
                  <>
                    {Number(items.Balance) !== 0 && (
                      <div className="TripClosureIndex">
                        <div className="TripClosureIndex0">
                          <div className="TripClosureGrp">
                            <p className="TripClosureGrpLables">Id</p>
                            <p className="TripClosureGrpValues">
                              {items.Booking_Id}
                            </p>
                          </div>
                          <div className="TripClosureGrp">
                            <p className="TripClosureGrpLables">Name</p>
                            <p className="TripClosureGrpValues">
                              {items.Customer_Name}
                            </p>
                          </div>
                          <div className="TripClosureGrp">
                            <p className="TripClosureGrpLables">Contact</p>
                            <p className="TripClosureGrpValues">
                              {items.Contact1}
                            </p>
                          </div>
                        </div>
                        <div className="TripClosureIndex1">
                          <p className="TripClosureGrpDT">{items.Bus_Name}</p>
                          <FontAwesomeIcon
                            className="TripClosureBusIcon"
                            style={
                              Number(items.Balance) === 0
                                ? { color: "green", opacity: "0.5" }
                                : { color: "red", opacity: "0.5" }
                            }
                            icon={faBus}
                          ></FontAwesomeIcon>
                          <p className="TripClosureGrpDT1">
                            {DateTimeConvert(
                              items.Departure_Datetime.toString()
                            )}
                          </p>
                          <div className="TripClosureGrpBtn">
                            <FontAwesomeIcon
                              className="TripClosureEditIcon"
                              title="Edit"
                              onClick={() => handleEdit(items)}
                              icon={faEdit}
                            ></FontAwesomeIcon>
                            <FontAwesomeIcon
                              className="TripClosureDeleteIcon"
                              title="Delete"
                              onClick={() => handleDelete(items)}
                              icon={faTrash}
                            ></FontAwesomeIcon>
                          </div>
                        </div>
                        <div className="TripClosureIndex2">
                          <div className="TripClosureGrp">
                            <p className="TripClosureGrpLables">Paid</p>
                            <p className="TripClosureGrpValues">
                              ₹ {items.Paid}
                            </p>
                          </div>
                          <div className="TripClosureGrp">
                            <p className="TripClosureGrpLables">Balance</p>
                            <p className="TripClosureGrpValues">
                              ₹ {items.Balance}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                );
              })
            )}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}

/*
 <button className='NewTripClosureBtn' >Add New<FontAwesomeIcon className='NewTripClosureIcon' icon={faPlus}></FontAwesomeIcon></button>
 */
